import { render, staticRenderFns } from "./EditDashboard.vue?vue&type=template&id=32f37de9"
import script from "./EditDashboard.vue?vue&type=script&lang=js"
export * from "./EditDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports